import {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import {logger} from '@/helpers/logger';

/**
 * Custom hook for handling errors in components
 * @returns {Object} Error handling functions
 */
export const useErrorHandler = () => {
  const navigate = useNavigate();

  /**
   * Handle API errors and other runtime errors
   * @param {Error} error - The error object
   */
  const handleError = useCallback(
    (error) => {
      logger.error('Error occurred:', error);

      // You can add additional error logging here
      // For now, we'll navigate to the error page
      navigate('/error/404');
    },
    [navigate]
  );

  /**
   * Handle API errors specifically
   * @param {Error} error - The API error object
   */
  const handleApiError = useCallback(
    (error) => {
      logger.error('API Error occurred:', error);

      // Navigate to error page
      navigate('/error/404');
    },
    [navigate]
  );

  /**
   * Handle component errors
   * @param {Error} error - The component error object
   */
  const handleComponentError = useCallback(
    (error) => {
      logger.error('Component Error occurred:', error);

      // Navigate to error page
      navigate('/error/404');
    },
    [navigate]
  );

  return {
    handleError,
    handleApiError,
    handleComponentError
  };
};
